import { ValueMultiple as e } from "./value-multiple.js";
import { ItemContent as u } from "./value-multiple-item/item-content/item-content.js";
import { ItemIcon as a } from "./value-multiple-item/item-icon/item-icon.js";
import { ItemRemove as g } from "./value-multiple-item/item-remove/item-remove.js";
import { ValueMultipleItem as o } from "./value-multiple-item/value-multiple-item.js";
const m = Object.assign(e, {
  Item: o
});
export {
  m as ComboboxTriggerValueMultiple,
  o as ComboboxTriggerValueMultipleItem,
  u as ComboboxTriggerValueMultipleItemContent,
  a as ComboboxTriggerValueMultipleItemIcon,
  g as ComboboxTriggerValueMultipleItemRemove
};
